import React from "react";
import { Spinner, Container, Row, Col } from "react-bootstrap";

const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <Container className="text-center py-5">
      <Row className="justify-content-center">
        <Col xs={12} className="mb-3">
          <Spinner animation="border" role="status" variant="light">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </Col>
        <Col xs={12}>
          <h4>{message}</h4>
        </Col>
      </Row>
    </Container>
  );
};

export default LoadingSpinner;
